import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userName: "",
  userImg: "",
  userId: "",
  orgName: "",
  orgImg: "",
  orgId: "",
  roleId: "",
  readOnly: 0,
  orgDate: "",
  country: "",
  address: "",
  woTimerMode: 0
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateUser: (state, action) => {
      state.userName = action.payload.user_name;
      state.userId = action.payload.user_id;
      state.userImg = action.payload.user_img;
      state.orgName = action.payload.name;
      state.orgImg = action.payload.org_img;
      state.orgId = action.payload.org_id;
      state.roleId = action.payload.role_id;
      state.readOnly = action.payload.read_only ? 1 : 0;
      state.orgDate = action.payload.create_date;
      state.country = action.payload.country;
      state.address = action.payload.address_1;
      state.woTimerMode = action.payload.wo_timer_mode ?? 0;
    },
    clearUser: (state, action) => {
      state.userName = "";
      state.userId = "";
      state.userImg = "";
      state.orgName = "";
      state.orgImg = "";
      state.orgId = "";
      state.roleId = "";
      state.readOnly = 0;
      state.orgDate = "";
      state.country = "";
      state.address = "";
      state.woTimerMode = 0;
    },
    setWoTimerMode: (state, action) => {
      state.woTimerMode = action.payload;
    },
  },
});

export const { updateUser, clearUser, setWoTimerMode } = userSlice.actions;

export default userSlice.reducer;
